import initMenus from './components/menus'
import initAccordions from './components/accordions'
import initReadMore from './components/readMore'
import initHeaderOnScroll from './utils/headerOnScroll'
import SmoothScroll from './utils/SmoothScroll'
import DrawLines from './components/DrawLines'
import StationCarousel from './components/StationCarousel'
import Itineraries from './components/Itineraries'
import HeroParallax from './components/HeroParallax'
import Explore from './components/Explore'
import FooterScroller from './components/FooterScroller'
import SeeAndDoFilter from './components/SeeAndDoFilter'
import StationFilter from './components/StationFilter'
import Quiz from './components/Quiz'

document.addEventListener('DOMContentLoaded', () => {
	new SmoothScroll()
	new DrawLines()
	new StationCarousel()
	new Itineraries()
	new HeroParallax()
	new Explore()
	new FooterScroller()
	new SeeAndDoFilter()
	new StationFilter()
	new Quiz()
	initMenus()
	initAccordions()
	initReadMore()
	initHeaderOnScroll()
})
